export default __webpack_public_path__ + "88a12f8e02c33de5004e4578ea586b58.png";